import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import type { Company } from '../../types'
import { loadCompanyFieldIds } from './companiesActions'

export const companiesAdapter = createEntityAdapter<Company>({
  selectId: company => company.id,
})

export const companiesSlice = createSlice({
  name: 'companies',
  initialState: companiesAdapter.getInitialState(),
  reducers: {
    addCompany(state, action: PayloadAction<Company>) {
      companiesAdapter.upsertOne(state, action.payload)
    },
    addCompanies(state, action: PayloadAction<Company[]>) {
      companiesAdapter.setAll(state, action.payload)
    },
  },
  extraReducers: builder => {
    builder.addCase(loadCompanyFieldIds.fulfilled, (state, action) => {
      const { companyId, fieldIds } = action.payload
      companiesAdapter.updateOne(state, { id: companyId, changes: { fieldIds } })
    })
  },
})

export default companiesSlice.reducer
